import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-20817806"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "text-primary" }, "Olete sisenenud Kriminaalhooldusportaali!", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-3" }, " Kriminaalhooldusportaali eesmärgiks on toetada Teie kriminaalhoolduse läbimist. Kriminaalhooldusega seotud informatsioon on koondunud siia ning täieneb pidevalt. Saate iseseivalt, endale sobival ajal tutvuda dokumentidega ja kõige muuga, mis kriminaalhooldust puudutab. Tegemist on Teie isikliku virtuaalse toimikuga. ", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-3" }, " Kui avalehe paremale poolele ilmub punase hüüumärgiga kastike, toimige vastavalt juhistele – ametnik soovib Teile olulist informatsiooni edastada või anda vajaliku juhise. ", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "px-2" }, "Planeeritud kohtumised ja tegevused", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "px-2 text-textDark text-justify mt-3" }, "Siit leiate kiire ülevaate järgmisest registreerimise ajast, sellega seotud kokkulepetest ning teistest planeeritud tegevustest. ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_VoHoiatus = _resolveComponent("VoHoiatus")!
  const _component_MinuAmetnik = _resolveComponent("MinuAmetnik")!
  const _component_TahelepanuTeavitused = _resolveComponent("TahelepanuTeavitused")!
  const _component_PlaneeritudKohtumisedTegevused = _resolveComponent("PlaneeritudKohtumisedTegevused")!
  const _component_KRHPPaigutus = _resolveComponent("KRHPPaigutus")!

  return (_openBlock(), _createBlock(_component_KRHPPaigutus, null, {
    pais: _withCtx(() => [
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card, { class: "pa-2" }, {
                        default: _withCtx(() => [
                          _hoisted_1,
                          _hoisted_2,
                          _hoisted_3
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_VoHoiatus, { class: "ma-2" })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_row, { class: "d-xl-none" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_MinuAmetnik)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_row, { class: "d-xl-none" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_TahelepanuTeavitused)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, null, {
                    default: _withCtx(() => [
                      _hoisted_4,
                      _hoisted_5
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_PlaneeritudKohtumisedTegevused)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            class: "d-none d-xl-block makslaius",
            cols: "auto"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_MinuAmetnik)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_TahelepanuTeavitused)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}